<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-row no-gutters class="mt-10 mb-4">
        <v-col cols="12" sm="4" md="4">
          <div class="d-flex mb-4">
            <h2>{{ this.$t("Breeder Report") }}</h2>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-tooltip top color="black" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="exportSemen"
              >
                <v-icon dark> mdi-export </v-icon>
              </v-btn>
            </template>
            <span>{{$t('reportsB.download')}}</span>
          </v-tooltip>

          <v-tooltip top color="black" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="
                  printPDF($refs.semen, 'Semen(Semen/Embryo Production Report)')
                "
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>{{$t('reportsB.print')}}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- filters -->
      <v-card class="mb-5 px-4 py-4 border rounded-lg" outlined>
        <v-row no-gutters>
          <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">{{$t('reports.filterByMonth')}}</label>
            <v-select
              :items="months"
              item-text="label"
              item-value="value"
              dense
              outlined
              class="mr-2"
              v-model="month"
              placeholder="Filter By Month"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">Filter By Date</label>
            <v-select
              :items="dates"
              dense
              outlined
              class="mr-2"
              v-model="date"
              placeholder="Filter By Date"
            ></v-select>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">Filter By Role</label>
            <v-select
              :items="roleList"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class=""
              v-model="role"
              placeholder="Filter By Role"
            ></v-select>
          </v-col> -->
        </v-row>
      </v-card>

      <!-- chips -->
      <v-row no-gutters>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar size="70" color="#e0fff3">
                <v-icon color="primary">mdi-poll</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ totalPregnant }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{$t("reportsB.totalPregnant")}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar size="70" color="#e0fff3">
                <v-icon color="primary">mdi-horse</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ totalNewBorn }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{$t("reportsB.totalNewBorn")}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar size="70" color="#e0fff3">
                <v-icon color="primary">mdi-needle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ totalInsemination }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{$t("reportsB.totalInsemination")}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  20
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  Total Products
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col> -->
      </v-row>

      <!-- tables -->
      <v-row>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex">
                <p class="mt-2 ml-4">{{$t('reportsB.conception')}}</p>
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </div>
            </template>
            <div ref="conception">
              <v-data-table
                :headers="headersForConception"
                :items="computedConception"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsConception"
                :server-items-length="totalConception"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>

                <template v-slot:[`item.conceptionMethod`]="{ item }">
                  {{ item.conceptionMethod }}
                </template>
                <template v-slot:item.birthOrigin.dateOfBirth="{ item }">
                  {{
                    item.birthOrigin &&
                    item.birthOrigin.dateOfBirth &&
                    new Date(item.birthOrigin.dateOfBirth)
                      .toISOString()
                      .split("T")[0]
                  }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex">
                <p class="mt-2 ml-4">{{$t('reportsB.semen')}}</p>
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </div>
            </template>
            <div ref="semen">
              <v-data-table
                :headers="headersForSemen"
                :items="computedSemen"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsSemen"
                :server-items-length="totalgenos"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:item.parentageInformation.createdAt="{ item }">
                  {{
                    item.parentageInformation &&
                    item.parentageInformation.createdAt &&
                    new Date(item.parentageInformation.createdAt)
                      .toISOString()
                      .split("T")[0]
                  }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex">
                <p class="mt-2 ml-4">Embryo</p>
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </div>
            </template>
            <div ref="embryo">
              <v-data-table
                :headers="headersForEmbryo"
                :items="itemsForEmbryo"
                :loading="embryoLoading"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsEmbryo"
                :server-items-length="totalEmbryo"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>

                <template v-slot:[`item.EmbryoMethod`]="{ item }">
                  {{ item.EmbryoMethod.name }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col> -->
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex">
                <p class="mt-2 ml-4">{{$t('reportsB.pregnancyCheck')}}</p>
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </div>
            </template>
            <div ref="pregnancy">
              <v-data-table
                :headers="headersForPregnancyCheck"
                :items="computedPregnancy"
                :items-per-page="5"
                hide-default-footer
              >
                <template v-slot:item.pregnancy_check_date="{ item }">
                  {{
                    item.pregnancy_check_date &&
                    item.pregnancy_check_date &&
                    new Date(parseInt(item.pregnancy_check_date))
                      .toISOString()
                      .split("T")[0]
                  }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex">
                <p class="mt-2 ml-4">{{$t('reportsB.birthInfo')}}</p>
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </div>
            </template>
            <div ref="birth">
              <v-data-table
                :headers="headersForBirthInfo"
                :items="itemsForBirthInfo"
                :items-per-page="5"
                :loading="birthLoading"
                hide-default-footer
                :options.sync="tableOptionsBirthInfo"
                :server-items-length="totalBirthInfo"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import FarmService from "@/_services/farmService.js";
import ProductService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import {
  conceptionInfo,
  semenInfo,
  pregnancyCheck,
} from "@/graphql/Breeder.gql";
export default {
  apollo: {
    conceptionData: {
      query: conceptionInfo,
      update: data => data.generalInformations,
    },
    semenData: {
      query: semenInfo,
      update: data => data.generalInformations,
    },
    pregnancyData: {
      query: pregnancyCheck,
      update: data => data.pregnancyTestAll,
    },
  },
  mounted() {
    let monthDays = this.daysInMonth(this.month);
    this.month = new Date().getMonth();
    this.date = new Date().getDate();

    for (let i = 0; i < monthDays; i++) {
      this.dates.push(i + 1);
    }
    document.title = "Analytics and Reporting";
    this.searchFarm(this.farm);
    this.getCount();
  },
  watch: {
    month: {
      handler(nV) {
        this.computedConception = this.conceptionData.filter(hd => {
          if (hd.birthOrigin && hd.birthOrigin.dateOfBirth) {
            let tmpDate = new Date(hd.birthOrigin.dateOfBirth);
            if (
              nV == tmpDate.getUTCMonth() &&
              this.date == tmpDate.getUTCDate()
            ) {
              return true;
            }
          } else {
            return false;
          }
        });
        this.computedSemen = this.semenData.filter(hd => {
          if (hd.parentageInformation && hd.parentageInformation.createdAt) {
            let tmpDate = new Date(hd.parentageInformation.createdAt);
            if (
              nV == tmpDate.getUTCMonth() &&
              this.date == tmpDate.getUTCDate()
            ) {
              return true;
            }
          } else {
            return false;
          }
        });
        this.computedPregnancy = this.pregnancyData.filter(hd => {
          let tmpDate = new Date(parseInt(hd.pregnancy_check_date));
          if (
            nV == tmpDate.getUTCMonth() &&
            this.date == tmpDate.getUTCDate()
          ) {
            return true;
          }
        });
      },
      immediate: false,
    },
    date: {
      handler(nV) {
        this.computedConception = this.conceptionData.filter(hd => {
          if (hd.birthOrigin && hd.birthOrigin.dateOfBirth) {
            let tmpDate = new Date(hd.birthOrigin.dateOfBirth);
            if (
              nV == tmpDate.getUTCDate() &&
              this.month == tmpDate.getUTCMonth()
            ) {
              return true;
            }
          } else {
            return false;
          }
        });
        this.computedSemen = this.semenData.filter(hd => {
          if (hd.parentageInformation && hd.parentageInformation.createdAt) {
            let tmpDate = new Date(hd.parentageInformation.createdAt);
            if (
              nV == tmpDate.getUTCDate() &&
              this.month == tmpDate.getUTCMonth()
            ) {
              return true;
            }
          } else {
            return false;
          }
        });
        this.computedPregnancy = this.pregnancyData.filter(hd => {
          let tmpDate = new Date(parseInt(hd.pregnancy_check_date));
          if (
            nV == tmpDate.getUTCDate() &&
            this.month == tmpDate.getUTCMonth()
          ) {
            return true;
          }
        });
      },
      immediate: true,
    },
    async farmSearch(val) {
      await this.searchFarm(val);
    },
    conceptionData: {
      handler(nV, oV) {
        console.log(nV, oV);
        this.totalInsemination = nV.length;
      },
      deep: true,
    },
    pregnancyData: {
      handler(nV, oV) {
        console.log(nV, oV);
        this.totalNewBorn = nV.filter(e => e.conception_success).length;
        this.totalPregnant = nV.length;
      },
      deep: true,
    },
    tableOptionsConception: {
      handler() {
        this.getConception();
      },
      deep: true,
    },
    tableOptionsSemen: {
      handler() {
        this.getSemen();
      },
      deep: true,
    },
    tableOptionsBirthInfo: {
      handler() {
        this.getBirthInfo();
      },
      deep: true,
    },
    tableOptionsEmbryo: {
      handler() {
        this.getEmbryo();
      },
      deep: true,
    },
    tableOptionsPregnancyCheck: {
      handler() {
        this.getPregnancyCheck();
      },
      deep: true,
    },
  },
  data: () => ({
    computedConception: [],
    computedSemen: [],
    pregnancyData: [],
    conceptionData: [],
    semenData: [],
    months: [
      { label: "Jan", value: 0 },
      { label: "Feb", value: 1 },
      { label: "Mar", value: 2 },
      { label: "Apr", value: 3 },
      { label: "May", value: 4 },
      { label: "Jun", value: 5 },
      { label: "Jul", value: 6 },
      { label: "Aug", value: 7 },
      { label: "Sep", value: 8 },
      { label: "Oct", value: 9 },
      { label: "Nov", value: 10 },
      { label: "Dec", value: 11 },
    ],
    roleList: [
      { roleNumber: 1, name: "Role 1" },
      { roleNumber: 2, name: "Role 2" },
      { roleNumber: 3, name: "Role 3" },
    ],
    role: 2,
    month: 0,
    dates: [],
    date: 0,
    totalPregnant: 0,
    totalNewBorn: 0,
    totalInsemination: 0,
    data: "",
    items: [],
    conceptionLoading: false,
    semenLoading: false,
    embryoLoading: false,
    pregnancyLoading: false,
    birthLoading: false,
    newItems: [],
    farmLoading: false,
    farmSearch: "",
    search: "",
    breadcrumbs: [
      // {
      //   text: this.$t("dashboard"),
      //   disabled: false,
      //   to: "/",
      // },
      // {
      //   text: this.$t("analyticsAndReporting"),
      //   disabled: false,
      // },
      // {
      //   text: this.$t("breederReport"),
      //   disabled: true,
      // },
      {
        text: "Dashboard",
        // text:  this.$t("dashboard"),
        disabled: false,
        to: "/",
      },
      {
        text: "Analytics and Reporting",
        disabled: true,
      },
      {
        text: "Breeder Report",
        disabled: true,
      },
    ],
    count: {},
    headersForSemen: [
      {
        text: "Semen Transfer Date",
        sortable: false,
        value: "parentageInformation.createdAt",
      },
      {
        text: "Sire ID",
        sortable: false,
        value: "parentageInformation.sireId",
      },
      { text: "Dam ID", sortable: false, value: "parentageInformation.damId" },
      {
        text: "Organization Name",
        sortable: false,
        value: "ownerBreedAssociation.nameOfBreedAssoc",
      },
      { text: "Dam Breed", sortable: false, value: "breed.name" },
    ],

    itemsForSemen: [],

    headersForEmbryo: [
      { text: "Embryo Transfer Date", sortable: false, value: "matingDate" },
      { text: "Sire ID", sortable: false, value: "sireId" },
      { text: "Dam ID", sortable: false, value: "surrogateDamId" },
      { text: "Embryo Org. Name", sortable: false, value: "embryoOrgName" },
      { text: "Recipient ID", sortable: false, value: "receipientId" },
      { text: "Embryo ID", sortable: false, value: "embryoId" },
    ],
    itemsForEmbryo: [],

    headersForConception: [
      {
        text: "Insemination Date",
        sortable: false,
        value: "birthOrigin.dateOfBirth",
      },
      {
        text: "Inseminator Name",
        sortable: false,
        value: "ownerBreedAssociation.owner",
      },
      {
        text: "Organization Name",
        sortable: false,
        value: "ownerBreedAssociation.nameOfBreedAssoc",
      },
      {
        text: "Breeding Service Number",
        sortable: false,
        value: "ownerBreedAssociation.breedAssocRegNo",
      },
      {
        text: "Conception Method",
        sortable: false,
        value: "birthOrigin.conceptionMethod.name",
      },
    ],
    itemsForConception: [],

    headersForPregnancyCheck: [
      {
        text: "Pregnancy Check Date",
        sortable: false,
        value: "pregnancy_check_date",
      },
      // { text: "Days of Pregnancy", sortable: false, value: "days" },
      {
        text: "Conception Success",
        sortable: false,
        value: "conception_success",
      },
      {
        text: "Pregnancy Check Operator",
        sortable: false,
        value: "pregnancy_check_operator",
      },
      {
        text: "Pregnancy Check Method",
        sortable: false,
        value: "pregnancy_check_method",
      },
    ],
    itemsForPregnancyCheck: [],

    headersForBirthInfo: [
      { text: "Delivery Date", sortable: false, value: "deliveryDate" },
      { text: "Calf ID", sortable: false, value: "calfId" },
      { text: "Birth Farm", sortable: false, value: "birthFarm" },
      { text: "Birth Ease", sortable: false, value: "birthEase.name" },
      {
        text: "Birth (day old) weight ",
        sortable: false,
        value: "birthWeight",
      },
    ],
    itemsForBirthInfo: [],

    tableOptionsSemen: {
      page: 1,
      itemsPerPage: 5,
    },
    fromSemen: 0,
    toSemen: 0,
    totalgenos: 1,
    totalPagesConceptionSemen: 1,

    tableOptionsEmbryo: {
      page: 1,
      itemsPerPage: 5,
    },
    fromEmbryo: 0,
    toEmbryo: 0,
    totalEmbryo: 1,
    totalPagesConceptionEmbryo: 1,

    tableOptionsConception: {
      page: 1,
      itemsPerPage: 5,
    },
    fromConception: 0,
    toConception: 0,
    totalConception: 1,
    totalPagesConception: 1,

    tableOptionsPregnancyCheck: {
      page: 1,
      itemsPerPage: 5,
    },
    fromPregnancyCheck: 0,
    toPregnancyCheck: 0,
    totalPregnancyCheck: 1,
    totalPagesConceptionPregnancyCheck: 1,

    tableOptionsBirthInfo: {
      page: 1,
      itemsPerPage: 5,
    },
    fromBirthInfo: 0,
    toBirthInfo: 0,
    totalBirthInfo: 1,
    totalPagesConceptionBirthInfo: 1,
  }),
  methods: {
    daysInMonth(month, year = new Date().getFullYear()) {
      return new Date(year, month, 0).getDate();
    },
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then(res => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },

    getCount() {
      this.startLoading();
      ProductService.getCountbreeder()
        .then(res => {
          console.log(res);
          if (res.success) {
            this.count = res.data;
            this.stopLoading();
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.loading = false;
        });
    },
    exportConception() {
      html2pdf(this.$refs.conception, {
        margin: 1,
        filename: "Conception Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportSemen() {
      html2pdf(this.$refs.semen, {
        margin: 1,
        filename: "Semen Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportEmbryo() {
      html2pdf(this.$refs.embryo, {
        margin: 1,
        filename: "Embryo Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportPregnancy() {
      html2pdf(this.$refs.pregnancy, {
        margin: 1,
        filename: "Pregnancy Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportbirth() {
      html2pdf(this.$refs.birth, {
        margin: 1,
        filename: "Birth Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getConception() {
      this.conceptionLoading = true;
      ProductService.getConception(this.tableOptionsConception, this.farm)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.itemsForConception = res.data.conceptionData.rows;
            this.currentrows = res.data.conceptionData.num_rows;
            this.totalConception = res.data.conceptionData.total_rows;
            this.pageCount = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.totalPagesConception = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.fromConception =
              (this.tableOptionsConception.page - 1) *
                this.tableOptionsConception.itemsPerPage +
              1;
            this.toConception =
              this.tableOptionsConception.page *
                this.tableOptionsConception.itemsPerPage -
              (this.tableOptionsConception.itemsPerPage -
                res.data.conceptionData.num_rows);
            this.conceptionLoading = false;
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeConception(t) {
      if (t)
        this.tableOptionsConception.page = this.tableOptionsConception.page + 1;
      else
        this.tableOptionsConception.page = this.tableOptionsConception.page - 1;

      this.getConception();
    },
    getSemen() {
      this.semenLoading = true;
      ProductService.getSemenDetails(this.tableOptionsSemen, this.farm)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.itemsForSemen = res.data.semenData.rows;
            this.currentrows = res.data.semenData.num_rows;
            this.totalgenos = res.data.semenData.total_rows;
            this.pageCount = Math.ceil(
              this.totalgenos / this.tableOptionsSemen.itemsPerPage
            );
            this.totalPagesConceptionSemen = Math.ceil(
              this.totalConception / this.tableOptionsSemen.itemsPerPage
            );
            this.fromSemen =
              (this.tableOptionsSemen.page - 1) *
                this.tableOptionsSemen.itemsPerPage +
              1;
            this.toSemen =
              this.tableOptionsSemen.page *
                this.tableOptionsSemen.itemsPerPage -
              (this.tableOptionsSemen.itemsPerPage -
                res.data.semenData.num_rows);
            this.semenLoading = false;
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeSemen(t) {
      if (t) this.tableOptionsSemen.page = this.tableOptionsSemen.page + 1;
      else this.tableOptionsSemen.page = this.tableOptionsSemen.page - 1;

      this.getSemen();
    },
    getEmbryo() {
      this.embryoLoading = true;
      ProductService.getEmbroyDetails(this.tableOptionsEmbryo, this.farm)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.itemsForEmbryo = res.data.embryoData.rows;
            this.currentrows = res.data.embryoData.num_rows;
            this.totalEmbryo = res.data.embryoData.total_rows;
            this.pageCount = Math.ceil(
              this.totalEmbryo / this.tableOptionsEmbryo.itemsPerPage
            );
            this.totalPagesConceptionEmbryo = Math.ceil(
              this.totalEmbryo / this.tableOptionsEmbryo.itemsPerPage
            );
            this.fromEmbryo =
              (this.tableOptionsEmbryo.page - 1) *
                this.tableOptionsEmbryo.itemsPerPage +
              1;
            this.toEmbryo =
              this.tableOptionsEmbryo.page *
                this.tableOptionsEmbryo.itemsPerPage -
              (this.tableOptionsEmbryo.itemsPerPage -
                res.data.embryoData.num_rows);
            this.embryoLoading = false;
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeEmbryo(t) {
      if (t) this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page + 1;
      else this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page - 1;
      this.getEmbryo();
    },

    getPregnancyCheck() {
      this.pregnancyLoading = true;
      ProductService.getPregnencyCheck(
        this.tableOptionsPregnancyCheck,
        this.farm
      )
        .then(res => {
          console.log(res);
          if (res.success) {
            this.itemsForPregnancyCheck = res.data.pregrencyCheckData.rows.map(
              a => {
                const obj = {
                  pregnancyCheckDate: a.pregnancyCheckDate,
                  conceptionSuccess: a.conceptionSuccess ? "Yes" : "No",
                  pregnancyCheckOperatorName: a.pregnancyCheckOperatorName,
                  pregnancyCheckMethod: a.pregnancyCheckMethod,
                  days: a.days,
                };
                return obj;
              }
            );
            this.currentrows = res.data.pregrencyCheckData.num_rows;
            this.totalPregnancyCheck = res.data.pregrencyCheckData.total_rows;
            this.pageCount = Math.ceil(
              this.totalPregnancyCheck /
                this.tableOptionsPregnancyCheck.itemsPerPage
            );
            this.totalPagesConceptionPregnancyCheck = Math.ceil(
              this.totalPregnancyCheck /
                this.tableOptionsPregnancyCheck.itemsPerPage
            );
            this.fromPregnancyCheck =
              (this.tableOptionsPregnancyCheck.page - 1) *
                this.tableOptionsPregnancyCheck.itemsPerPage +
              1;
            this.toPregnancyCheck =
              this.tableOptionsPregnancyCheck.page *
                this.tableOptionsPregnancyCheck.itemsPerPage -
              (this.tableOptionsPregnancyCheck.itemsPerPage -
                res.data.pregrencyCheckData.num_rows);
            this.pregnancyLoading = false;
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeCheck(t) {
      if (t)
        this.tableOptionsPregnancyCheck.page =
          this.tableOptionsPregnancyCheck.page + 1;
      else
        this.tableOptionsPregnancyCheck.page =
          this.tableOptionsPregnancyCheck.page - 1;

      this.getPregnancyCheck();
    },
    getBirthInfo() {
      this.birthLoading = true;
      ProductService.getBirthInfo(this.tableOptionsBirthInfo, this.farm)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.itemsForBirthInfo = res.data.birthInfoData.rows;
            this.currentrows = res.data.birthInfoData.num_rows;
            this.totalBirthInfo = res.data.birthInfoData.total_rows;
            this.pageCount = Math.ceil(
              this.totalBirthInfo / this.tableOptionsBirthInfo.itemsPerPage
            );
            this.totalPagesConceptionBirthInfo = Math.ceil(
              this.totalBirthInfo / this.tableOptionsBirthInfo.itemsPerPage
            );
            this.fromBirthInfo =
              (this.tableOptionsBirthInfo.page - 1) *
                this.tableOptionsBirthInfo.itemsPerPage +
              1;
            this.toBirthInfo =
              this.tableOptionsBirthInfo.page *
                this.tableOptionsBirthInfo.itemsPerPage -
              (this.tableOptionsBirthInfo.itemsPerPage -
                res.data.birthInfoData.num_rows);
            this.birthLoading = false;
          }
        })
        .catch(err => {
          this.stopLoading();
          console.log(err);
          this.birthLoading = false;
        });
    },
    pageChangeBirth(t) {
      if (t)
        this.tableOptionsBirthInfo.page = this.tableOptionsBirthInfo.page + 1;
      else
        this.tableOptionsBirthInfo.page = this.tableOptionsBirthInfo.page - 1;

      this.getBirthInfo();
    },
    async getProductByCat() {
      console.log(this.farm);
      await this.getConception();
      await this.getSemen();
      await this.getEmbryo();
      await this.getPregnancyCheck();
      await this.getBirthInfo();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>
